<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="float-right" v-if="!loading" id="viewOrderActions">
                    <div class="dropdown">
                        <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMen1" data-toggle="dropdown" data-boundary="viewport" aria-haspopup="true" aria-expanded="false">
                            Actions
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenu1">
                            <button class="dropdown-item" id="btnViewOrderCancel" @click="onCancelOrderClick"
                                    v-show="order.orderStatusId !== orderStatus.cancelled && order.orderStatusId !== orderStatus.complete">
                                Cancel
                            </button>
                            <button class="dropdown-item" id="btnViewOrderDownload" @click="downloadOrderAsPdf">
                                Download
                            </button>
                            <button class="dropdown-item" id="btnOrderDocuments" @click="viewOrderDocuments"
                                    v-show="order.orderStatusId === orderStatus.complete">
                                Documents
                            </button>
                            <button class="dropdown-item" id="btnViewOrderViewTrackingHistory" @click="viewTrackingHistory">
                                View Tracking History
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="!loading">
                    <div class="pb-2">
                        <p>
                            Customer: {{order.registeredCompanyName}}
                        </p>
                        <!--                        <p v-if="order.customerBranch">-->
                        <!--                            Branch: {{order.customerBranch}}-->
                        <!--                        </p>-->
                        <p>
                            Order Date: {{order.insertedOn}}
                        </p>
                        <p>
                            Order Type: {{order.orderType}}
                        </p>
                        <p>
                            Order Status: {{order.description}}
                        </p>
                        <!--                        <p v-if="order.placedBy">-->
                        <!--                            Placed By: {{order.placedBy}} (#{{order.placedByUserId}})-->
                        <!--                        </p>-->
                        <p v-if="order.expectedDateOfDelivery">
                            Expected Date Of Delivery: {{order.expectedDateOfDelivery}}
                        </p>
                        <p v-if="order.orderStatusId === orderStatus.complete">
                            Date of Collection: {{order.statusLastUpdatedOn}}
                        </p>
                    </div>
                    <div class="card border border-secondary mb-3">
                        <div class="card-body text-secondary">
                            <div class="row">
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Billing Address</h5>
                                    <p v-if="!loadingBillingAddress">
                                        <span v-if="billingAddress">
                                            {{ billingAddress.siteName }}<br>
                                            {{ billingAddress.streetAddress }}<br>
                                            {{ billingAddress.city }} <br>
                                            {{ billingAddress.province }} <br>
                                            {{ billingAddress.postalCode }}<br>
                                            <!--                                {{ billingAddress.country }}-->
                                        </span>
                                                <span v-else>
                                            No billing address found.
                                        </span>
                                    </p>
                                    <p v-if="loadingBillingAddress">Loading...</p>
                                </div>
                                <div class="col-6">
                                    <h5 class="card-title text-secondary">Vehicle Details</h5>
                                    <p>
                                        Vehicle Registration: {{orderVehicle.vehicleRegistration}}
                                    </p>
                                    <p>
                                        Fleet Number: {{order.fleetNumber}}
                                    </p>
                                    <p>
                                        Manifest Number: {{order.manifestNumber}}
                                    </p>
                                    <p>
                                        Odometer Reading: {{orderDispensed.vehicleOdometerReading}}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card border border-secondary pt-2">
                        <div class="card-body text-secondary">
                            <h5 class="card-title text-secondary">Items Ordered</h5>
                            <order-items-table
                                    :orderId="orderId"
                                    :orderTotal="orderGrandTotal"></order-items-table>
                            
                        </div>
                    </div>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>
    <div class="modal fade" :id="cancelOrderModalId" tabindex="-1" aria-labelledby="cancelOrderModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modal-header-warning">
                    <h5 class="modal-title" id="cancelOrderModalLabel">Cancel Order #{{order.orderId}}?</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    Cancel Order? Are you sure?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal">
                        No
                    </button>
                    <button type="button" class="btn btn-outline-primary waves-effect waves-light"
                            @click="onCancelYesClick"
                            :disabled="loading">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    </div>
    <tracking-history-modal
            :heading="trackingHistoryModal.heading"
            :modalId="trackingHistoryModal.modalId"
            :showModal="trackingHistoryModal.showModal"
            :orderId="trackingHistoryModal.orderId"
            @okButtonClicked="onTrackingHistoryOkButtonClicked"></tracking-history-modal>
    <order-documents-modal
            :orderId="documentsModal.orderId"
            :heading="documentsModal.heading"
            :modalId="documentsModal.modalId"
            :showModal="documentsModal.showModal"
            :orderTypeId="documentsModal.orderTypeId"
            @closeModal="onDocumentsModalClose"></order-documents-modal>
</div>
